<template>
  <v-container class="justify-center page-container mb-12" max-width="900">
    <v-sheet height="62" class="title-container d-flex align-center">
      <div class="title">{{this.$t('albums.title')}}</div>
    </v-sheet>
    <v-sheet class="mx-auto">
      <div
        class="d-flex flex-column justify-center"
        style="height: 300px"
        v-if="albums.length == 0 && !loading"
      >
        <div class="d-flex justify-center mt-12">
          <div class="text-center">{{$t('albums.table.albums_empty_remind_text')}}</div>
        </div>

        <div class="d-flex justify-center ma-4" v-if="albums.length == 0">
          <v-btn
            class="text-center"
            color="primary"
            rounded
            @click="createAlbum"
          >{{$t('albums.table.add_album')}}</v-btn>
        </div>
      </div>
    </v-sheet>

    <v-sheet class="mx-auto" v-if="groupingAlbums.public.length != 0 && !loading">
      <v-simple-table fixed-header>
        <template v-slot:default>
          <thead>
            <tr class="table-header">
              <!-- <th class="text-left">home.table.album_cover</th> -->
              <th class="text-left">
                <div class="table-header-item-1">{{$t('albums.table.album_cover')}}</div>
              </th>
              <th class="text-left">
                <div class="table-header-item-2">{{$t('albums.table.album_name')}}</div>
              </th>
              <th class="text-left">
                <div class="table-header-item-2">{{$t('albums.table.album_state')}}</div>
              </th>
              <th class="text-left">
                <div class="table-header-item-2">{{$t('album_form.share_scope')}}</div>
              </th>
              <th class="text-left">
                <div class="table-header-item-2">{{$t('albums.table.ctime')}}</div>
              </th>
              <th class="text-left">
                <div class="table-header-item-2">{{$t('albums.table.sheet_count')}}</div>
              </th>
              <th class="text-left">
                <div class="table-header-item-2">{{$t('albums.table.operation')}}</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in groupingAlbums.public" :key="item.name">
              <td>
                <v-avatar size="62" color="grey" tile @click="selectAlbum(item)" class="cover">
                  <v-img :src="commonUtils.getImageUrl(item.data.cover_uuid)"></v-img>
                </v-avatar>
              </td>
              <td @click="selectAlbum(item)" class="name">{{ getAlbumName(item) }}</td>
              <td>{{ getReleaseState(item) }}</td>
              <td>
                <div>
                  <span>{{ getScope(item.scope) }}</span>
                  <v-tooltip
                    color="#FFCF31"
                    v-model="show"
                    top
                    v-if="item.reviewing_sheet_count > 0"
                  >
                    <template v-slot:activator="{ on }">
                      <span
                        class="reviewing-number review-container"
                        v-on="on"
                      >{{item.reviewing_sheet_count}}</span>
                    </template>
                    <span
                      class="black--text"
                    >{{ $t('albums.text.sheet_reviewing', [item.reviewing_sheet_count])}}</span>
                  </v-tooltip>

                  <v-tooltip
                    color="#E96969"
                    v-model="show"
                    top
                    v-if="item.rejected_sheet_count > 0 "
                  >
                    <template v-slot:activator="{ on }">
                      <span
                        class="review-failed-number review-container"
                        v-on="on"
                      >{{item.rejected_sheet_count}}</span>
                    </template>
                    <span
                      class="black--text"
                    >{{ $t('albums.text.sheet_reviewing_failed', [item.rejected_sheet_count])}}</span>
                  </v-tooltip>
                </div>
              </td>
              <td>{{ convertTimeFormat(item.ctime) }}</td>
              <td>{{ item.sheet_count}}</td>
              <td>
                <v-btn
                  height="26"
                  depressed
                  color="primaryLight primary--text"
                  rounded
                  class="upload-sheet-btn"
                  @click="uploadSheet(item)"
                >{{$t('albums.table.create_sheet')}}</v-btn>
              </td>
            </tr>
            <tr>
              <div class="mb-12"></div>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-sheet>

    <v-sheet class="mx-auto mt-4" v-if="groupingAlbums.private.length != 0 && !loading">
      <v-simple-table fixed-header>
        <template v-slot:default>
          <thead>
            <tr class="table-header">
              <!-- <th class="text-left">home.table.album_cover</th> -->
              <th class="text-left">
                <div class="table-header-item-1">{{$t('albums.table.album_cover')}}</div>
              </th>
              <th class="text-left">
                <div class="table-header-item-2">{{$t('albums.table.album_name')}}</div>
              </th>
              <th class="text-left">
                <div class="table-header-item-2">{{$t('albums.table.album_state')}}</div>
              </th>
              <th class="text-left">
                <div class="table-header-item-2">{{$t('album_form.share_scope')}}</div>
              </th>
              <th class="text-left">
                <div class="table-header-item-2">{{$t('albums.table.ctime')}}</div>
              </th>
              <th class="text-left">
                <div class="table-header-item-2">{{$t('albums.table.sheet_count')}}</div>
              </th>
              <th class="text-left">
                <div class="table-header-item-2">{{$t('albums.table.operation')}}</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in groupingAlbums.private" :key="item.name">
              <td>
                <v-avatar size="62" color="grey" tile @click="selectAlbum(item)" class="cover">
                  <v-img :src="commonUtils.getImageUrl(item.data.cover_uuid)"></v-img>
                </v-avatar>
              </td>
              <td @click="selectAlbum(item)" class="name">{{ getAlbumName(item) }}</td>
              <td>{{ getReleaseState(item) }}</td>
              <td>
                <div>
                  <span>{{ getScope(item.scope) }}</span>

                  <v-tooltip
                    color="#FFCF31"
                    v-model="show"
                    top
                    v-if="item.reviewing_sheet_count > 0"
                  >
                    <template v-slot:activator="{ on }">
                      <span
                        class="reviewing-number review-container"
                        v-on="on"
                      >{{item.reviewing_sheet_count}}</span>
                    </template>
                    <span
                      class="black--text"
                    >{{ $t('albums.text.sheet_reviewing', [item.reviewing_sheet_count])}}</span>
                  </v-tooltip>

                  <v-tooltip
                    color="#E96969"
                    v-model="show"
                    top
                    v-if="item.rejected_sheet_count > 0 "
                  >
                    <template v-slot:activator="{ on }">
                      <span
                        class="review-failed-number review-container"
                        v-on="on"
                      >{{item.rejected_sheet_count}}</span>
                    </template>
                    <span
                      class="black--text"
                    >{{ $t('albums.text.sheet_reviewing_failed', [item.rejected_sheet_count])}}</span>
                  </v-tooltip>
                </div>
              </td>
              <td>{{ convertTimeFormat(item.ctime) }}</td>
              <td>{{ item.sheet_count}}</td>
              <td>
                <v-btn
                  height="26"
                  depressed
                  color="primaryLight primary--text"
                  rounded
                  class="upload-sheet-btn"
                  @click="uploadSheet(item)"
                >{{$t('albums.table.create_sheet')}}</v-btn>
              </td>
            </tr>
            <tr>
              <div class="mb-12"></div>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-sheet>
    <v-sheet class="mx-auto mt-4" v-if="loading" >
      <div class="d-flex flex-column justify-center" style="height: 300px">
        <div class="d-flex justify-center">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary mt-12"
            indeterminate
          ></v-progress-circular>
        </div>
      </div>
    </v-sheet>
  </v-container>
</template>


<script>
export default {
  name: "Albums",
  data: function() {
    return {
      albums: [],
      loading: false,
      groupingAlbums: { private: [], public: [] }
    };
  },
  created: function() {},
  mounted() {
    this.$store.commit("setCurrentScore", { score: null });
    this.$store.commit("setCurrentAlbum", { album: null });
    this.$store.commit("setCurrentSheet", { sheet: null });
    this.getUserAlbums();
  },
  methods: {
    getScope: function(scope) {
      return this.commonUtils.getShareScope(scope, this);
    },
    getAlbumName: function(album) {
      if (!album || !album.data) {
        return "";
      }
      const currentLan = this.$i18n.locale;
      if (album.data[`name_${currentLan}`]) {
        return album.data[`name_${currentLan}`];
      } else {
        return album.data.name_base || album.data.name;
      }

      // return album.data.name
    },
    convertTimeFormat: function(timeString) {
      return this.commonUtils.convertTimeFormat(timeString);
    },
    getReleaseState: function(album) {
      //   if (album.release_status == null) {
      //     if (album.scope == "public") {
      //       return this.$t("album.sheet_state.reviewing");
      //     } else {
      //       return this.$t("album.sheet_state.online");
      //     }
      //   } else {
      //     return album.state;
      //   }
      return this.commonUtils.getAlbumReleaseStatus(
        this,
        album.release_status,
        album.review_status
      );
    },
    getUserAlbums: function() {
      const userUuid = this.$store.getters.userUuid;

      console.log("get albums", userUuid);
      this.loading = true;
      if (userUuid) {
        this.commonUtils
          .getGroupingAlbumsByUuid(userUuid, this)
          .then(response => {
            console.log("userUuid is", userUuid, "try to get uuid");
            if (response) {
              this.loading = false;
              const albums = [...response.public, ...response.private];
              this.groupingAlbums = {
                public: response.public,
                private: response.private
              };
              albums.forEach(album => (album.review_result = {}));
              this.$store.commit("setAlbums", { albums });
              this.albums = albums;
              for (const album of albums) {
                this.commonUtils
                  .getAlbumReviewsResult(this, album.uuid)
                  .then(reviewResult => {
                    const review_result = {};
                    reviewResult.forEach(review => {
                      if (review.review_status == "rejected") {
                        review_result.rejected = review.count;
                      }
                      if (review.review_status == "reviewing") {
                        review_result.reviewing = review.count;
                      }
                    });
                    album.review_result = review_result;
                    console.log("review result", album.review_result);
                  });
              }
              console.log("this.albums", this.albums);
            }
          });
      } else {
      }
    },
    createAlbum: function() {
      this.$store.commit("setCurrentAlbum", { current_album: null });
      this.$store.commit("setRouteBackTo", {route_back_to: 'albums'});
      this.$router.replace({
        name: "create_album"
      });
    },
    selectAlbum: function(album) {
      this.commonUtils.toAlbumDetail(this, album);
    },
    uploadSheet: function(album) {
      this.$store.commit("setCurrentAlbum", { album: album });
      this.$router.push({
        name: "upload_sheet"
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../assets/css/font.css";
.title {
  font-size: 20px;
}
.subtitle {
  font-size: 20px;
}
.title-container {
  margin-bottom: 20px;
  padding-left: 20px;
  border-radius: 8px;
}
.cover {
  cursor: pointer;
  margin-bottom: 16px;
  margin-top: 16px;
  margin-left: 20px;
}
.name {
  cursor: pointer;
}

.table-header {
  height: 62px;
  padding-left: 100px;
}
.table-header-item-1 {
  height: 62px;
//   font-family: SHRegular;
  font-weight: normal;
  /* font-family: /; */
  color: #999999;
  //   color: red;
  vertical-align: middle !important;
  font-size: 14px;
  padding-left: 22px;
  font-weight: 500;
  padding-top: 20px;
}
.table-header-item-2 {
  height: 62px;
  color: #999999;
  //   font-family: SHRegular;
  font-weight: 500;
  vertical-align: middle !important;
  font-size: 14px;
  padding-top: 20px;
}
.container {
  padding: 30px;
}

.add_sheet_btn {
  background-color: "#DBEBFF";
}

.upload-sheet-btn {
  font-size: 14px;
}

.review-container {
  border-radius: 2px;

  // border-style: solid;
  padding-left: 4px;
  padding-right: 4px;
  margin-left: 4px;
}

.reviewing-number {
  background-color: #ffcf31;
}

.review-failed-number {
  background-color: #e96969;
}
</style>
